/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebShareFolderModel,
  IWebShareFolderRequest,
  IMappers,
  IWebShareFolderResponse,
  IWebShareFolderResponseError,
  TWebShareFolderResponse,
} from './types';

const defaultConfig: TWebShareFolderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'shared-folders',
  pathApi: '/v1/web/share-folder/',
  hostType: 'api',
} as TWebShareFolderModel;

function createWebShareFolderModel(parameters: IWebShareFolderRequest): TWebShareFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebShareFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebShareFolderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebShareFolder<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebShareFolderOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TWebShareFolderResponse> {
  const { response, statusCode } = await httpApi.fetch(createWebShareFolderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebShareFolderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebShareFolderResponseError);
    }
  }

  return { response, statusCode } as TWebShareFolderResponse;
}

export { defaultConfig, createWebShareFolderModel, fetchWebShareFolder };
